import { ActionTimestamp } from "../../../action";
import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../SetInventory/SetInventory";
import { ActionEntry } from "../../ActionEntries";

export const applyOutcomesSets = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
  newActionTimestamps: ActionTimestamp[],
  buyAmount: number = 1,
) => {
  // Apply Outcomes (both bricks and sets)
  for (let i = 0; i < action.outcome.length; i++) {
    const outcomeEntry = action.outcome[i];
    const trueOutcome =
      outcomeEntry.baseChangeValue * action.outcomeScale * buyAmount;

    // Default to "brick" if type not specified (backward compatibility)
    const outcomeType = outcomeEntry.type || "brick";

    if (outcomeType === "brick") {
      // Apply brick outcomes
      const currBrick = newBricks.get(outcomeEntry.brickId)!;

      // Respect capacity limit for bricks
      currBrick.amount = Math.min(
        currBrick.capacity,
        trueOutcome + currBrick.amount,
      );

      const timestamp: ActionTimestamp = {
        id: currBrick.id,
        amount: trueOutcome,
        timestamp: Date.now(),
      };

      newActionTimestamps.push(timestamp);
    } else if (outcomeType === "set") {
      // Apply set outcomes (no capacity limit, just increment count)
      const currSet = newSets.get(outcomeEntry.brickId)!; // brickId field contains set ID
      currSet.count += trueOutcome;

      // No timestamp for sets for now (could add later if needed for activity feed)
    }
  }

  return { newBricks, newSets };
};
